module.exports = __webpack_public_path__ + "img/Corona_australis.6f973893.png";